import { ReactNode, useEffect } from "react";
import styles from "./style.module.scss";

import PageContainer from "@components/layout/PageContainer";
import { Table } from "reactstrap";
import CircleButton from "@components/content/CircleButton";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useAdminContext } from "@/hooks/useAdminContext";

export const TYPE_OF_DOCUMENTS: DocumentTypes = {
  invoice_email: "Facturas",
  qoute_email: "Cotizaciones",
  consignment_email: "Consignaciones",
  creditnote_email: "Notas de Credito",
  debitnote_email: "Notas de Debito",
  providerorder_email: "Ordenes de Compra Proveedores",
  recibe_email: "Recibo de Dinero",
  settlement_email: "Liquidaciones",
  clientstatus_email: "Estado de cuenta",
  order_email: "Ordenes de Compra ",
}

type DocumentTypes = {
  invoice_email: string;
  qoute_email: string;
  consignment_email: string;
  creditnote_email: string;
  debitnote_email: string;
  providerorder_email: string;
  recibe_email: string;
  settlement_email: string;
  clientstatus_email: string;
  order_email: string;
}

export type DocumentEmailTemplateIds = "invoice_email" | "qoute_email" | "consignment_email" | "creditnote_email" | "debitnote_email" | "providerorder_email" | "recibe_email" | "settlement_email" | "clientstatus_email" | "order_email";

/**
 * Tipos que no se muestran en el listado (siguen existiendo en el modelo/backend, solo se
 * oculta la opcion de editarlos desde aqui).
 */
const HIDDEN_FROM_LIST: DocumentEmailTemplateIds[] = ["consignment_email", "order_email"];

const EmailTemplates = () => {
  const { profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const generateTableRows = (): ReactNode[] => {
    return Object.entries(TYPE_OF_DOCUMENTS)
      .filter(([type]) => !HIDDEN_FROM_LIST.includes(type as DocumentEmailTemplateIds))
      .map(([type, title]) => {
      return (
        <tr className={styles.row}>
          <td>{title}</td>
          <td>
            <CircleButton to={`/user/email-template/${type}${adminQuerySuffix}`} tooltip="Editar Plantilla" iconProps={{ icon: faEdit }} />
          </td>
        </tr>
      )
    })

  }

  return (
    <PageContainer
      title="Plantillas de Correo"
      backUrl={profileBackUrl}
    >
      <Table striped bordered>
        <thead className={styles.header}>
          <tr>
            <td>
              Tipo De Documento
            </td>
            <td>
              Accion
            </td>
          </tr>
        </thead>
        <tbody>
          {generateTableRows()}
        </tbody>
      </Table>

    </PageContainer>
  );
}

export default EmailTemplates;
